import { render } from "./MessageFiles.vue?vue&type=template&id=70e53564"
import script from "./MessageFiles.vue?vue&type=script&lang=js"
export * from "./MessageFiles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__